<template>
  <div>
    <template v-if="type == 'inbox'">
      <report-message-graph :type="type" :date="date" :app="app"></report-message-graph>
    </template>
    <template v-else-if="type == 'comment'">
      <v-layout wrap>
        <v-flex xs12 sm6 md4>
          <report-message-graph
            :type="type"
            :date="date"
            :app="app"
            :commenttype="'replycomment'"
            :fbpost="fbpost"
          ></report-message-graph>
        </v-flex>

        <v-flex xs12 sm6 md4>
          <report-message-graph
            :type="type"
            :date="date"
            :app="app"
            :commenttype="'replyinbox'"
            :fbpost="fbpost"
          ></report-message-graph>
        </v-flex>

        <v-flex xs12 sm6 md4>
          <report-message-graph
            :type="type"
            :date="date"
            :app="app"
            :commenttype="'hidecomment'"
            :fbpost="fbpost"
          ></report-message-graph>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
import ReportMessageGraph from './ReportMessageGraph'

export default {
  props: ['type', 'date', 'app', 'fbpost'],
  components: {
    ReportMessageGraph
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/ReportMessage.vue